import { useState } from 'react';
import Modal from './ui/Modal';
interface Props {
  page: string;
  props?: string;
}
export default function WebComponentSnippet({ page, props }: Props) {
  const [isShowing, setIsShowing] = useState(false);

  const jsSnippet = `<script
  type="module"
  src="https://kia-pages-cdn.vercel.app/widget/widget.js"
></script>`;

  const kebabize = (str: string) =>
    str.replace(
      /[A-Z]+(?![a-z])|[A-Z]/g,
      ($, ofs) => (ofs ? '-' : '') + $.toLowerCase(),
    );

  const makeIntoDataProp = (props = '') => {
    if (!props) return '';

    return props
      .match(/([a-zA-ZäöåÄÖÅ-]+)="([^"]*)"/g) // Updated regex to capture everything within quotes
      .map((e) => {
        const [key, value] = e.split(/=(.+)/); // Split only at the first equals sign
        return `${kebabize(key)}=${value}`;
      })
      .join(' ');
  };

  const htmlSnippet = `<kia-widget kia-page="${page}" ${makeIntoDataProp(props) ?? ''}></kia-widget>`;

  const copySnippet = () => {
    navigator.clipboard.writeText(`${jsSnippet}\n${htmlSnippet}`);
  };
  return (
    <>
      {isShowing ? (
        <Modal clickOutside={() => setIsShowing(false)}>
          <div className="bg-white p-4">
            <h2 className="text-center text-2xl">Kodsnutt</h2>
            <p className="text-center">
              Kopiera koden nedan och klistra in i ett frikodsblock
            </p>
            <p className="text-center">
              Scriptet ska endast laddas en gång per sida
            </p>
            <div className="bg-black p-4 text-white rounded-xl my-4">
              <pre className="text-sm">{jsSnippet}</pre>
            </div>
            <div className="bg-black p-4 text-white rounded-xl my-4 max-w-lg overflow-auto">
              <pre className="text-sm">{htmlSnippet}</pre>
            </div>
            <div className="flex justify-center gap-4">
              <button onClick={copySnippet} className="bg-black text-white p-2">
                Kopiera
              </button>
              <button
                onClick={() => setIsShowing(false)}
                className="bg-black text-white p-2"
              >
                Stäng
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
      <button
        onClick={() => setIsShowing(true)}
        className="z-10 fixed rounded-xl bg-black border-white border text-white p-2 bottom-2 left-2"
      >
        Visa webbkomponent kodsnutt
      </button>
    </>
  );
}
